import React from "react";
import { AppBar, Toolbar, Typography, IconButton, Menu, MenuItem, Avatar } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import { useNavigate } from "react-router-dom";
export default function Header({ open, setOpen }) {
    const navigate = useNavigate();
    const [anchorEl, setAnchorEl] = React.useState(null);
    const handleMenu = (event) => setAnchorEl(event.currentTarget);
    const handleClose = () => setAnchorEl(null);
    const handleLogout = () => {
        handleClose();
        localStorage.removeItem("token");
        navigate("/");
    };
    return (
        <AppBar position="fixed" sx={{ zIndex: 1201, backgroundColor: "#2575fc" }}>
            <Toolbar>
                <IconButton color="inherit" edge="start" onClick={() => setOpen(!open)} sx={{ mr: 2 }}><MenuIcon /></IconButton>
                <Typography variant="h6" sx={{ flexGrow: 1 }}>Admin Panel</Typography>
                <IconButton color="inherit" onClick={handleMenu}>
                    <Avatar sx={{ bgcolor: "#fff", color: "#2575fc" }}>A</Avatar>
                </IconButton>
                <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleClose}>
                    <MenuItem onClick={handleLogout}>Logout</MenuItem>
                </Menu>
            </Toolbar>
        </AppBar>
    );
}